import React from 'react';
import { Helmet } from 'react-helmet';

import { SaldoCard } from '@components';

import { Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PerfilInvestimentoPage } from './perfilInvestimento';
import { OutrosCard } from '../../common/components/CardsHome/Outros';
import { InvestimentosCard } from '../../common/components/CardsHome/Investimentos';
import { ContribuicoesCard } from '../../common/components/CardsHome/Contribuicoes';
import { PERFIL_INVESTIMENTO } from '../../common/utils/paths';

export const PlanoBPage = () => {
  const { tabela_contribuicao: showTabelaContribuicao } = useSelector(
    (state) => state.telasDisponiveis
  );

  return (
    <>
      <Helmet>
        <title>Forluz - Plano B</title>
      </Helmet>
      <Routes>
        <Route
          path="*"
          element={
            <>
              <h1 className="page-title mb-5">
                <strong>Plano B</strong>&nbsp;
                <span className="fw-light">CEMIG Saúde</span>
              </h1>
              <div className="row mb-4">
                <div className="col-12">
                  <SaldoCard />
                </div>
              </div>
              <div className="row">
                {showTabelaContribuicao && (
                  <div className="col-12 col-md-6 col-lg-4 mb-4">
                    <ContribuicoesCard />
                  </div>
                )}

                <div className="col-12 col-md-6 col-lg-8">
                  <InvestimentosCard />
                  <OutrosCard />
                </div>
              </div>
            </>
          }
        />
        <Route
          path={PERFIL_INVESTIMENTO}
          element={<PerfilInvestimentoPage />}
        />
      </Routes>
    </>
  );
};
